module.exports = App.AdvertsController = Em.Controller.extend
  queryParams: ['actuality']
  env:     Em.inject.service('environment')

  advertsEnabled: Em.computed.alias('env.features.advertsEnabled')
  loyaltyEnabled: Em.computed.alias('env.features.loyaltyProgramsEnabled')
  bonusCategoriesEnabled:   Em.computed.alias('env.features.bonusCategories')
  clientTagsEnabled:   Em.computed.alias('env.features.enableClientTagAutoassign')


